import { render, staticRenderFns } from "./SixFreeOne.vue?vue&type=template&id=976c2432&scoped=true"
import script from "./SixFreeOne.vue?vue&type=script&lang=js"
export * from "./SixFreeOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "976c2432",
  null
  
)

export default component.exports